import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import Cookie from "js-cookie";
import * as utils from "@/utils";
import webSocketService from "./utils/websocketService";
// import { getToken } from '@/utils/auth' // getToken from cookie

import { asyncRouterMap, constantRouterMap } from "@/router";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

// permission judge function
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

const whiteList = ["/login", "/auth-redirect", "/white", 
"/white-device", "/deviceMan/mbInitiateProcess"
]; // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  let userRoles = window.localStorage.userRoles;
  if (Cookie.get("Token") && userRoles && Cookie.get("userId")) {
    // determine if there has token
    /* has token*/
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.addRouters.length == 0) {
        // 根据权限返回路由表
        let roles = JSON.parse(decodeURI(userRoles));
        store.dispatch("GenerateRoutes", { roles }).then(() => {
          // 根据roles权限生成可访问的路由表
          router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
          
          // 初始化WebSocket连接
          webSocketService.initWebSocket(JSON.parse(window.localStorage.userInfo), roles);
          
          next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        });
      } else {
        next();
      }
      // -- 业务协同添加气泡
      setTimeout(() => {
        utils.setBubble();
      }, 1000)

      // 最近访问
      let zjfwLocalData;

      if (!window.localStorage.zjfwLocalData) {
        zjfwLocalData = [];
      } else {
        zjfwLocalData = JSON.parse(window.localStorage.zjfwLocalData);
      }
      // 是否存在
      let isHas = false;
      for (let item of zjfwLocalData) {
        if (item.name == to.name) {
          isHas = true;
          break;
        }
      }

      if (!isHas && to.path != "/dashboard" && to.name != null) {
        let obj = {
          name: to.name,
          path: to.path
        };
        zjfwLocalData.unshift(obj);
        if (zjfwLocalData.length > 10) {
          zjfwLocalData.pop();
        }
        console.log("zjfwLocalData", JSON.stringify(zjfwLocalData));
        window.localStorage.zjfwLocalData = JSON.stringify(zjfwLocalData);
      }

      // if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
      //   store.dispatch('GetUserInfo').then(res => { // 拉取user_info
      //     const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
      //     store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
      //       router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
      //       next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      //     })
      //   }).catch((err) => {
      //     store.dispatch('FedLogOut').then(() => {
      //       Message.error(err || 'Verification failed, please login again')
      //       next({ path: '/' })
      //     })
      //   })
      // } else {
      //   alert('adsfadsfa')
      //   // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
      //   if (hasPermission(store.getters.roles, to.meta.roles)) {
      //     next()
      //   } else {
      //     next({ path: '/401', replace: true, query: { noGoBack: true }})
      //   }
      //   // 可删 ↑
      // }
    }
  } else {
    let hasRole = false
    console.log('===to.path', to.path)

    for (let item of whiteList) {
      console.log('===item',item)
      if (to.path.indexOf(item) >=0) {
        hasRole = true
        break
      }
    }
    console.log('===hasRole', hasRole)
    /* has no token*/
    // whiteList.indexOf(to.path) !== -1
    if (hasRole) {
      console.log("===白名单-直接走");
      // 在免登录白名单，直接进入
      next();
    } else {
      // Message({
      //   type: 'warning',
      //   message: '登录超时，请您重新登录'
      // })
      next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
      NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});

// 路由错误捕获
router.onError((error, to, from) => {
  NProgress.done(); // finish progress bar
  console.log("----路由报错");
  console.log("error", error);
  console.log("to", to);
  console.log("from", from);
  Message.warning("系统已升级，请【刷新浏览器】重试");
});
